module.exports = __webpack_public_path__ + "static/media/inf_36og47.52532f53.mp3";